export default {
    container: {
        height: "80vh",
        display: "flex",
        flexDirection: "column",
        p: 2,
    },
    buttons: {
        // margin: (theme) => `${theme.spacing(0.5)} 0`,
    },
    stepper: {
        marginBottom: 2,
    },
    locationContainer: {
        maxHeight: "calc(65vh - 300px)",
        overflowY: "auto",
        border: "1px solid #ccc",
        borderRadius: "8px",
        p: 1,
        "& .MuiGrid-item": {
            px: 2,
        },
    },
    navButtons: {
        my: 1,
        display: "flex",
        justifyContent: "space-between",
    },
    searchField: {
        marginBottom: "20px",
    },
    card: (isSelected) => ({
        cursor: "pointer",
        position: "relative",
        backgroundColor: isSelected ? "#d1e7dd" : "white",
        border: isSelected ? "2px solid #0f5132" : "1px solid #ccc",
        borderRadius: "8px",
        px: 5,
        py: 1,
        transition: "background-color 0.3s, border 0.3s",
        "& .MuiCardContent-root": {
            p: 0,
            paddingBottom: "0 !important",
        },
    }),
    checkbox: {
        position: "absolute",
        top: "-2px",
        left: "-2px",
        zIndex: 1,
        fontSize: "1rem",
    },
    pagination: {
        marginTop: "20px",
        display: "flex",
        justifyContent: "center",
    },
    stepsContainer: {
        maxHeight: "60vh",
        overflow: "scroll",
        padding: "8px",
    },
    chipContainer: {
        maxHeight: "30vh",
        overflow: "scroll",
        marginTop: "10px",
    },
    emptyMessage: {
        marginTop: "10px",
        color: "textSecondary",
    },
    exclusionReason: { width: "100%", paddingBottom: 2 },
    spinnerContainer: {
        justifyContent: "center",
        position: "absolute",
        width: "100%",
        display: "flex",
        top: "50%",
    },
    zoneContainer: {
        padding: 0,
    },
    auditProgressValue: {
        border: "none",
    },
    auditProgressListContainer: {
        display: "inline-block",
        padding: 1,
        "&:first-of-type": {
            paddingLeft: 0,
        },
        "&:last-child": {
            border: "none",
            paddingRight: 0,
        },
    },
    auditProgressCaption: {
        // color: theme.palette.text.darkText,
        fontWeight: 500,
        fontSize: "0.7rem",
        textTransform: "uppercase",
    },
    listContainer: {
        p: 2,
        "& hr": {
            borderBottom: (theme) =>
                `1px solid ${theme.palette.border.darkBorder}`,
        },
        "& li": {
            "& .MuiListItemIcon-root": { minWidth: "30px" },
            px: 1,
            py: 2,
        },
    },
    locationModal: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 400,
        bgcolor: "background.paper",
        boxShadow: 24,
        borderRadius: 2,
        p: 4,
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        width: "90vw",
    },
    locationList: {
        height: "50vh",
        overflow: "scroll",
    },
    locationItem: {
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        borderBottom: "1px solid ",
    },
    modalBox: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        background: "#fff",
        boxShadow: 24,
        // borderRadius: (theme) => `${theme.spacing(1)}`,
        borderRadius: 2,
        // padding: (theme) => `${theme.spacing(2)} ${theme.spacing(4)}`,
        p: 2,
        whiteSpace: "nowrap",
        display: "flex",
    },
    listDetail: {
        display: "flex",
        flexDirection: "column",
    },
    iconTextContainer: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        " & svg": {
            marginRight: "10px",
        },
    },
    progress: {
        alignSelf: "center",
        marginRight: 2,
        // marginRight: (theme) => `${theme.spacing(4)}`,
    },
};
